export default __webpack_public_path__ + "static/media/antp_Electromovilidad_BannerCuadro_.dc3f349a.jpg";